import type { Presentation } from '../../types';
import { PresentationContainer } from './PresentationContainer';
import { DeepLinkCta } from './DeepLinkCta';

interface Props {
  p: Extract<Presentation, { type: 'composite' }>;
}

// Per DESIGN: when proximity returns multiple geocoded facilities we render a
// single response card containing a map on top, a table list below, and the
// summarizer's prose at the bottom. AssistantMessage suppresses the standalone
// prose div when the envelope is composite so the narrative renders here only.
export function CompositePresentation({ p }: Props) {
  return (
    <div className="presentation-card presentation-card--composite">
      <div className="composite-parts">
        {p.parts.map((part, i) => (
          <div key={i} className="composite-part">
            <PresentationContainer p={part} />
          </div>
        ))}
      </div>
      {p.prose && (
        <div className="composite-prose" aria-live="polite">{p.prose}</div>
      )}
      {p.cta && <DeepLinkCta cta={p.cta} />}
    </div>
  );
}
